export default __webpack_public_path__ + "static/media/NoProjectMissingProject.dafef4c9.svg";